import { TableCell, withStyles } from '@material-ui/core';

export default withStyles(() => ({
  head: {
    fontWeight: 700,
    fontSize: '0.8125rem',
  },
  body: {
    fontSize: '0.8125rem',
  },
}))(TableCell);
